import React from 'react'
import GalleryImages from '../../Movie/GalleryImages'
import VideoGallery from '../../Movie/GalleryVideos/VideoGallery'
import { truevalueedit } from '../../Movie/truevalueedit'
import AwsConfig from '../../../Config/AwsConfig'
import { Auth } from 'aws-amplify'
import { toast } from 'react-toastify'
import { ToastStyle } from '../../Data/MovieStaticData'
import Updateperson from '../../../Services/Mutations/Updateperson'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'

function Gallery(props) {
  const {
    activeSection,
    handleSectionClick,
    PersoninputData,
    sendInputPersondata,
    sendValuechangedBoolean,
    section,
    getUpdatedData,
    valueChanged,
    personData,
    setLoader,
  } = props
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const validation = () => valueChanged.GalleryImages || valueChanged.GalleryVideos

  const GalleryVideos = input => {
    if (PersoninputData.GalleryVideos && PersoninputData.GalleryVideos.length > -1) {
      const galleryVideos = PersoninputData.GalleryVideos.map(e => ({
        path: e.path.replace(AwsConfig.movieCdnUrl, ''),
        title: e.title,
        thumbnail: e.thumbnail ? e.thumbnail : '',
        videoPlatform: e.videoPlatform,
        // galleryTags: e.galleryTags,
        ...(e.galleryTags && e.galleryTags.length > 0 && { galleryTags: e.galleryTags }),
      }))
      // input.galleryVideos = galleryVideos
      // GalleryVideos
      truevalueedit([valueChanged.GalleryVideos, galleryVideos], input, 'galleryVideos')
    }
  }

  const galleryUpdatedTime = input => {
    if (PersoninputData.imageUpdatedTime) {
      truevalueedit(
        [valueChanged.GalleryImages, PersoninputData.imageUpdatedTime],
        input,
        'imageUpdatedTime',
      )
    }
  }

  const GalleryImagesUpdate = input => {
    if (PersoninputData.GalleryImages && PersoninputData.GalleryImages.length > -1) {
      const galleryImages = PersoninputData.GalleryImages.map(e => ({
        path: e.path.replace(AwsConfig.movieCdnUrl, ''),
        title: e.title,
        // galleryTags: e.galleryTags && e.galleryTags.length >= 1 ? e.galleryTags : null,
        ...(e.galleryTags && e.galleryTags.length > 0 && { galleryTags: e.galleryTags }),
      }))
      // input.galleryImages = galleryImages

      truevalueedit([valueChanged.GalleryImages, galleryImages], input, 'galleryImages')
    }

    return input
  }

  const saveGallery = async () => {
    setLoader(true)
    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }
    GalleryVideos(input)
    GalleryImagesUpdate(input)
    galleryUpdatedTime(input)
    try {
      const upadatelog = await Updateperson(input)
      if (upadatelog.statusCode === 'A002') {
        toast.success('Updated person successfully', ToastStyle)
        getUpdatedData()
        setLoader(false)
        // return upadatelog
      }
    } catch (error) {
      setLoader(false)
      console.warn(error)
    }
  }

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingTwo'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseTwo'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseTwo'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          <span>Gallery</span>
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseTwo'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingTwo'
        data-bs-parent='#accordion'
      >
        <GalleryImages
          // disableInput={disableInput}
          inputData={PersoninputData}
          galleryType={'person'}
          ImageType={'person'}
          GalleryImages={PersoninputData.GalleryImages}
          sendinputdata={sendInputPersondata}
          sendBooleanValueChangeDone={sendValuechangedBoolean}
        />
        <VideoGallery
          // disableInput={disableInput}
          inputData={PersoninputData}
          GalleryVideos={PersoninputData.GalleryVideos ? PersoninputData.GalleryVideos : []}
          sendinputdata={sendInputPersondata}
          sendBooleanValueChangeDone={sendValuechangedBoolean}
        />
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          <button
            className='btn btn-primary'
            onClick={() => saveGallery()}
            disabled={!validation()}
          >
            save
          </button>
          <button className='btn btn-secondary' onClick={() => getUpdatedData()}>
            cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default Gallery
